export default {
    DOCUMENTS: "Документы"
};
